module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp3_2.9a06b51d.png";